import { render, staticRenderFns } from "./AddressBook.vue?vue&type=template&id=25cdd932&scoped=true&"
import script from "./AddressBook.vue?vue&type=script&lang=js&"
export * from "./AddressBook.vue?vue&type=script&lang=js&"
import style0 from "./AddressBook.vue?vue&type=style&index=0&id=25cdd932&lang=scss&scoped=true&"
import style1 from "./AddressBook.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25cdd932",
  null
  
)

export default component.exports